// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","Logo":"Header_Logo__tPES7","Empty":"Header_Empty__5D9eE","SubHeader":"Header_SubHeader__04tSx"};